export default __webpack_public_path__ + "img/ai-integration.5a98440f.png";